// extracted by css-extract-rspack-plugin
export default {"root":"aBPFSf","first-row":"OZUQJY","firstRow":"OZUQJY","second-row":"IxMuED","secondRow":"IxMuED"};